// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".with-excerpt-layout{margin-left:0.5rem;margin-right:0.5rem}.with-excerpt-layout .layout-article{margin-bottom:1rem;overflow:hidden;border-bottom-width:1px;padding-bottom:1rem}.with-excerpt-layout .layout-article figure{margin-bottom:0.5rem}.with-excerpt-layout .layout-article .content .category-name{display:none}.with-excerpt-layout .layout-article .content h1, .with-excerpt-layout .layout-article .content h2{font-size:2.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
